/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2CalendarNote/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2CalendarNote({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2CalendarNote",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2CalendarNote.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-ZLAvFv': alignSelf,'--mt-2-ZLAvFv': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZLAvFv': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZLAvFv': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZLAvFv': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZLAvFv': opacity,'--w-10-ZLAvFv': typeof width === 'number' ? `${width}px` : width,'--h-11-ZLAvFv': typeof height === 'number' ? `${height}px` : height,'--f-12-ZLAvFv': fill,'--a-7-ZLAvFv': isAnimated ? animation : "none",'--sd-8-ZLAvFv': isAnimated ? strokeDashoffset : 0,'--sd-9-ZLAvFv': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2CalendarNote.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M3.5 0a1 1 0 011 1v1h5V1a1 1 0 112 0v1h1A1.5 1.5 0 0114 3.5v9a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 010 12.5v-9A1.5 1.5 0 011.5 2h1V1a1 1 0 011-1zm-.125 7c0-.345.28-.625.625-.625h6a.625.625 0 110 1.25H4A.625.625 0 013.375 7zM4 9.375a.625.625 0 100 1.25h3a.625.625 0 100-1.25H4z"
 style={{'--f-12-ZLAvFv': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}